//
// Module for the User Workflow Control
//
rs.module("controls/userworkflow",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrls, redirectBackTo) {

            var filter = $.js(jsSelectors.filter);
            var modeRadioContainer = filter.js(jsSelectors.modeRadioContainer);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Setup listeners on filter inputs to perform actions
            modeRadioContainer.find("input").on("click", () => modeChanged());

            // Handle the mode changed event
            function modeChanged() {

                loadingSpinner.show();

                var selectedMode = modeRadioContainer.find("input:checked").val();

                gridModule.update(

                    backendUrls.getGridData,

                    {
                        selectedMode: selectedMode,
                        redirectBackTo: redirectBackTo
                    },

                    lrsGridApi.agGridApi,

                    function done(gridUpdate) {
                        loadingSpinner.hide();
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);